<div style="height:100%;width:100%;min-height:600px;">
  <h1 class="siila-blue-color">Listings</h1>
</div>
